/**
 * Create Writer Poll
 * @param {string} storyId
 * @param {number} partId
 * @param {string} type // poll type
 * @param {string} question
 * @param {Array} [options]
 * @returns {poll: object} - Returns the writer poll object
 */

const clientAPICall = (url, data) => {
  return Promise.resolve(
    $.ajax({
      type: "post",
      url,
      data,
      contentType: "application/json; charset=utf-8",
      dataType: "json",
      xhrFields: {
        withCredentials: true
      }
    })
  );
};

module.exports = function(storyId, partId, type, question, options) {
  return new Promise(function(resolve, reject) {
    const url = `${
      wattpad?.apiDomain
    }/writing/v1/stories/${storyId}/parts/${partId}/polls`;

    const data = {
      poll: {
        type,
        question,
        options
      }
    };

    clientAPICall(url, JSON.stringify(data))
      .then(poll => {
        return resolve(poll);
      })
      .catch(err => {
        return reject(err);
      });
  });
};
